import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { RECINTO_ADUANEIRO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    RECINTO_ADUANEIRO_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    RECINTO_ADUANEIRO_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [RECINTO_ADUANEIRO_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [RECINTO_ADUANEIRO_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [RECINTO_ADUANEIRO_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [RECINTO_ADUANEIRO_ENDPOINT],
    id
  );
}
